import { component } from 'picoapp';
import getProductItemsFromClerkResponse from 'utils/get-product-items-from-clerk-response';
import { ClerkResponse } from '../../typescript/Clerk';

export default component(async (node) => {
  const productList = node.querySelector('[data-product-list]');
  const sliderElement: HTMLElement = node.querySelector('[data-slider]');
  const prevBtn: HTMLElement = node.querySelector('[data-prev-btn]');
  const nextBtn: HTMLElement = node.querySelector('[data-next-btn]');

  interface ProductSliderConfig {
    clerkEndpoint: string
    clerkLabel: string
    limit: number
    productId: number
    productsSource: 'clerk' | 'collection' | 'manual'
  }

  const config: ProductSliderConfig = JSON.parse(node.dataset.config);
  const {
    clerkEndpoint, clerkLabel, limit, productId, productsSource,
  } = config;

  const fetchProductItems = () => new Promise<string[]>((resolve) => {
    if (!Clerk) {
      console.error('Clerk not found on window. Please check that Clerk is enabled in theme settings'); // eslint-disable-line no-console
      resolve([]);
    }

    Clerk(
      'call',
      clerkEndpoint,
      {
        labels: [clerkLabel],
        products: [productId],
        limit,
        attributes: ['handle'],
      },
      async (clerkResponse: ClerkResponse) => {
        const productItems = await getProductItemsFromClerkResponse(clerkResponse, 'product-item');

        resolve(productItems);
      },
      (clerkResponse: ClerkResponse) => {
        console.error(clerkResponse.message); // eslint-disable-line no-console
        resolve([]);
      },
    );
  });

  const renderProductItems = (productItems: string[]) => {
    const html = productItems.map((item) => (
      `<li class="product-slider__item swiper-slide">${item}</li>`
    )).join('');
    productList.innerHTML = html;

    Clerk('click', '*[data-clerk-product-id]');
  };

  const initSlider = async () => {
    const { default: Swiper, FreeMode, Navigation } = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    ));

    (() => new Swiper(sliderElement, {
      modules: [FreeMode, Navigation],
      slidesPerView: 'auto',
      freeMode: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'slider-arrow--disabled',
      },
    }))();
  };

  const observe = () => {
    const observer = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        if (productsSource === 'clerk') {
          const productItems = await fetchProductItems();
          renderProductItems(productItems);
        }

        await initSlider();
        observer.disconnect();
      }
    });

    observer.observe(node);
  };

  const init = () => {
    observe();
  };

  init();
});
